import type { ReactNode } from "react";
import { useNavigate } from "@tanstack/react-router";
import { useCurrentUser, isAdmin } from "@/hooks/use-current-user";
import { useEffect } from "react";

interface RequireAdminProps {
  children: ReactNode;
}

export function RequireAdmin({ children }: RequireAdminProps) {
  const { currentUser, isLoading } = useCurrentUser();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && !isAdmin(currentUser?.role)) {
      void navigate({ to: "/dashboard" });
    }
  }, [currentUser, isLoading, navigate]);

  if (isLoading || !isAdmin(currentUser?.role)) {
    return null;
  }

  return <>{children}</>;
}
